import { useState, useEffect } from "react";
import Modal from "react-modal";
import "./style.css";

import Sidebar from "../../componente/sidebar/index.jsx";
import PageHeader from "../../componente/topbar/index.jsx";

import { useAppContext } from "../../pages/context/AppContext.jsx";
import { useCrud } from "../../hooks/useCrud";

import { toast } from "react-hot-toast";
import api from "../../services/api.js";

Modal.setAppElement("#root");

function Categoria() {

  const { codusuario } = useAppContext();

  /* ==============================
     IMPORTAÇÃO DINÂMICA (CRA)
  ============================== */

  const importarImagens = () => {
    const contexto = require.context(
      "../../assets/Categoria",
      false,
      /\.png$/
    );
    const imagens = {};
    contexto.keys().forEach((key) => {
      const nomeArquivo = key
        .replace("./", "")
        .replace(".png", "");
      const index = parseInt(nomeArquivo) - 1;
      imagens[index] = contexto(key);
    });
    return imagens;
  };

  const imagens = importarImagens();

  /* ============================== */

  const [sidebarAberto, setSidebarAberto] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editando, setEditando] = useState(null);

  const {
    dados: categorias,
    loading,
    error,
    listar,
    buscarUm,
    criar,
    editar,
    excluir
  } = useCrud({
    rotaLista: "v1/categoria",
    rotaUm: "v1/categoriaum"
  });

  useEffect(() => {
    listar({ codusuario });
  }, []);

  const [form, setForm] = useState({
    indexcategoria: 1,
    descricao: ""
  });

  const abrirModal = async (item = null) => {
    if (item) {      
      const dados = await buscarUm({
        codcategoria: item.codcategoria,
        codusuario
      });
      setEditando(dados.codcategoria);
      setForm({
        codcategoria: dados.codcategoria,
        indexcategoria: dados.indexcategoria,
        descricao: dados.descricao
      });
    } else {
      setEditando(null);
      setForm({
        indexcategoria: 1,
        descricao: ""
      });
    }
    setModalOpen(true);
  };

  const salvar = async () => {
    const dt1 = new Date();
    const date1 =
      dt1.getFullYear() +
      "-" +
      (dt1.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt1.getDate().toString().padStart(2, "0");
    const time1 =
      dt1.getHours().toString().padStart(2, "0") +
      ":" +
      dt1.getMinutes().toString().padStart(2, "0");
    if (!form.descricao) {
      toast.error("Informe a descrição");
      return;
    }
    if (editando) {
      await editar({
        dtalteracao: `${date1}T${time1}`,
        codcategoria: editando,
        indexcategoria: form.indexcategoria,
        descricao: form.descricao
      });
    } else {
      await criar({
        dtalteracao: `${date1}T${time1}`,
        codusuario,
        indexcategoria: form.indexcategoria,
        descricao: form.descricao
      });

    }

    setModalOpen(false);

  };

  const excluirCategoria = async (codcategoria) => {

    if (!window.confirm("Deseja realmente excluir esta categoria?")) return;

    await excluir({
      codcategoria,
      codusuario
    });

  };

  return (
    <>
      <PageHeader
        titulo="Categorias"
        subtitulo="Organize suas entradas e saídas"
        abrirMenu={() => setSidebarAberto(true)}

        botaoAdicionar
        textoAdicionar="Nova Categoria"
        onAdicionar={() => abrirModal()}
      />

      <div className="categoria-container">

        <Sidebar
          aberto={sidebarAberto}
          fechar={() => setSidebarAberto(false)}
        />

        <div className="categoria-wrapper">

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
          ) : (

            <div className="categoria-list">

              {categorias.map((c) => (

                <div
                  key={c.codcategoria}
                  className="categoria-card"
                  onClick={() => abrirModal(c)}
                >

                  <div className="categoria-left">

                    <img
                      src={imagens[c.indexcategoria]}
                      alt=""
                    />

                    <strong>{c.descricao}</strong>

                  </div>

                  <button
                    className="btn-delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      excluirCategoria(c.codcategoria);
                    }}
                  >
                    Excluir
                  </button>

                </div>

              ))}

            </div>

          )}

          <Modal
            isOpen={modalOpen}
            onRequestClose={() => setModalOpen(false)}
            className="modal-content"
            overlayClassName="modal-overlay"
          >

            <div className="modal-header">
              <h3>
                {editando ? "Editar Categoria" : "Nova Categoria"}
              </h3>
            </div>

            <div className="modal-body">

              <div className="modal-imagens">

                {Object.keys(imagens).map((i) => (

                  <img
                    key={i}
                    src={imagens[i]}
                    alt=""
                    className={
                      form.indexcategoria === parseInt(i)
                        ? "ativo"
                        : ""
                    }
                    onClick={() =>
                      setForm({
                        ...form,
                        indexcategoria: parseInt(i)
                      })
                    }
                  />

                ))}

              </div>

              <input
                type="text"
                placeholder="Descrição da categoria"
                value={form.descricao}
                onChange={(e) =>
                  setForm({
                    ...form,
                    descricao: e.target.value
                  })
                }
              />

            </div>

            <div className="modal-footer">

              <button
                className="btn-cancelar"
                onClick={() => setModalOpen(false)}
              >
                Cancelar
              </button>

              <button
                className="btn-salvar"
                onClick={salvar}
              >
                Salvar
              </button>

            </div>

          </Modal>

        </div>

      </div>
    </>
  );
}

export default Categoria;